export class CostCenterRequest {
    CostCenterId: string;
}